import Component from '@glimmer/component';
import type {
  CustomEmberTableColumn,
  CustomEmberTableRow,
  TdComponentSignature,
} from '@mylighthouse/prism-ember/types/components/prism/table';

// The row holds one `*Display` object per metric (e.g. `roomNightsDisplay`);
// the column tells this cell which one to read via `displayKey`.
interface VarianceColumn extends CustomEmberTableColumn {
  displayKey: string;
}

interface VarianceDisplay {
  delta?: string;
  deltaColor?: string;
}

interface VarianceRow extends CustomEmberTableRow {
  hasComparison: boolean;
}

export default class NetRevenueCostDrilldownSectionTdVariance extends Component<TdComponentSignature> {
  private get column(): VarianceColumn {
    return this.args.column as VarianceColumn;
  }

  get delta(): string {
    return this.display.delta ?? '';
  }

  get deltaColor(): string {
    return this.display.deltaColor ?? '';
  }

  private get display(): VarianceDisplay {
    return this.row[this.column.displayKey] ?? {};
  }

  private get row(): VarianceRow {
    return this.args.row as VarianceRow;
  }

  get showDelta(): boolean {
    return this.showVariance && this.delta !== '';
  }

  get showVariance(): boolean {
    return this.row.hasComparison === true;
  }

  <template>
    <div class="flex flex-col tabular-nums">
      <span class="truncate">{{@displayValue}}</span>
      {{#if this.showDelta}}
        <span
          class="text-200--regular truncate {{this.deltaColor}}"
          data-test-id="variance-value"
        >
          {{this.delta}}
        </span>
      {{/if}}
    </div>
  </template>
}
